// TOC-42423 （Resource管理）
// ref: https://confluence.zhihuiya.com/pages/viewpage.action?pageId=115898889
// TOC-42424 （Service 维护）
// ref: https://confluence.zhihuiya.com/pages/viewpage.action?pageId=116987797
// TOC-42425 （Capacity管理）
// ref: https://confluence.zhihuiya.com/pages/viewpage.action?pageId=117003057
export var E_ResourceStatus;
(function (E_ResourceStatus) {
    E_ResourceStatus["ENABLED"] = "ENABLED";
    E_ResourceStatus["DISABLED"] = "DISABLED";
})(E_ResourceStatus || (E_ResourceStatus = {}));
export var E_ResourceCategory;
(function (E_ResourceCategory) {
    E_ResourceCategory["DATA"] = "DATA";
    E_ResourceCategory["USAGE"] = "USAGE";
    E_ResourceCategory["MAXIMUM"] = "MAXIMUM";
})(E_ResourceCategory || (E_ResourceCategory = {}));
export var E_ResourceCategoryType;
(function (E_ResourceCategoryType) {
    E_ResourceCategoryType["CAPACITY"] = "CAPACITY";
    E_ResourceCategoryType["PERFORMANCE_LIMITATION"] = "PERFORMANCE_LIMITATION";
})(E_ResourceCategoryType || (E_ResourceCategoryType = {}));
/**
 * 容量周期相关
 */
export var E_ResourceCyclical;
(function (E_ResourceCyclical) {
    E_ResourceCyclical["NONE"] = "NONE";
    E_ResourceCyclical["YEARLY"] = "YEARLY";
    E_ResourceCyclical["MONTHLY"] = "MONTHLY";
    E_ResourceCyclical["WEEKLY"] = "WEEKLY";
    E_ResourceCyclical["DAILY"] = "DAILY";
    E_ResourceCyclical["HOURLY"] = "HOURLY";
    E_ResourceCyclical["MINUTELY"] = "MINUTELY";
})(E_ResourceCyclical || (E_ResourceCyclical = {}));
export var E_FeatureTagType;
(function (E_FeatureTagType) {
    E_FeatureTagType["CAPACITY"] = "CAPACITY";
    E_FeatureTagType["FEATURE"] = "FEATURE";
})(E_FeatureTagType || (E_FeatureTagType = {}));
// #endregion
